<template>
  <div>
    <GrupoFamiliar
      v-if="carregado"
      :idFuncionalidade="idFuncionalidade"
      @click="proximo"
    />
  </div>
</template>
<script>

import GrupoFamiliar from '@/components/GrupoFamiliar/GrupoFamiliar'
import { mapGetters } from 'vuex'
export default {
  name: 'TemplateStepGrupoFamiliar',
  components: { GrupoFamiliar },
  props: {
    step: {
      type: Object
    },
    idFuncionalidade: {
      type: [Number, String],
      default: -23
    }
  },
  computed: {
    ...mapGetters('Login', ['isLogin'])
  },
  data () {
    return {
      carregado: false
    }
  },
  methods: {
    verificaBypass () {
      if (!this.isLogin) {
        return this.bypass()
      }

      this.carregado = true
    },
    bypass () {
      const payloadStep = {
        bypass: true
      }
      this.$emit('proximo', payloadStep)
    },
    proximo (payload) {
      this.$emit('proximo', {
        beneficiario: { ...payload }
      })
    }
  },
  mounted () {
    this.verificaBypass()
  }
}
</script>
<style scoped>
</style>
